import { inject, Injectable } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import OneSignal, { NotificationClickEvent, NotificationWillDisplayEvent } from 'onesignal-cordova-plugin';
import { of } from 'rxjs';
import { filter, first, switchMap } from 'rxjs/operators';
import { Auth } from 'src/app/core/common/auth';
import { log, Logger } from 'src/app/core/helpers/logger';
import { environment } from 'src/environments/environment';

@Injectable()
export class Push {
  private auth = inject(Auth);
  private platform = inject(Platform);
  private logger = inject(Logger);
  private phone: string;
  public init(
    onPushOpened: (ev: NotificationClickEvent) => void = () => {},
    onPushReceived: (ev: NotificationWillDisplayEvent) => void = (event: NotificationWillDisplayEvent) => {
      event.getNotification().display();
    }
  ) {
    if (this.platform.is('capacitor')) {
      OneSignal.initialize(environment.oneSignalAppId);

      OneSignal.Notifications.requestPermission(true).then(accepted => {
        if (accepted) {
          log('@push: user accepted notifications permission');
          OneSignal.User.pushSubscription.optIn();
        } else {
          this.logger.warn('@push: user refused notifications permission');
        }
      });

      OneSignal.Notifications.addEventListener('click', onPushOpened);
      OneSignal.Notifications.addEventListener('foregroundWillDisplay', onPushReceived);
      OneSignal.Location.setShared(true);

      this.auth.isAuthenticated$
        .pipe(
          switchMap(isAuthenticated => {
            return isAuthenticated
              ? this.auth.registeredUser$.pipe(
                  filter(user => !!user), // filtering null values on auth.user$ because it might not be ready by the time isAuthenticated is true
                  first()
                )
              : of(null);
          })
        )
        .subscribe(user => {
          try {
            if (user?.sub) {
              OneSignal.login(user.sub);
              this.phone = user.preferred_username.toString();
              if (this.phone) {
                OneSignal.User.addSms(this.phone);
              }
              OneSignal.User.pushSubscription.optIn();
            } else {
              if (this.phone) {
                OneSignal.User.removeSms(this.phone);
                this.phone = null;
              }
              OneSignal.User.pushSubscription.optOut();
              OneSignal.logout();
            }
          } catch (err) {
            this.logger.error('@push: failed to update OneSignal user', { err });
          }
        });
    } else {
      // add browser push configs
    }
  }
}
